(function () {
  'use strict';

  function initFoldBlogs() {
    document.querySelectorAll('[data-js-fold-blog]').forEach(function (root) {
      if (root.dataset.jsFoldBlogReady === 'true') return;
      root.dataset.jsFoldBlogReady = 'true';

      root.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-js-fold-toggle]');
        if (!toggle || !root.contains(toggle)) return;

        event.preventDefault();
        var card = toggle.closest('[data-js-fold-card]');
        if (!card) return;

        var isOpen = card.classList.toggle('is-open');
        card.querySelectorAll('[data-js-fold-toggle]').forEach(function (control) {
          control.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
        var label = card.querySelector('[data-js-fold-label]');
        if (label) label.textContent = isOpen ? 'Less' : 'More';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFoldBlogs);
  } else {
    initFoldBlogs();
  }

  document.addEventListener('shopify:section:load', initFoldBlogs);
})();
